module.exports = __webpack_public_path__ + "static/contextMenu-d5d5dadded2892edff9c20a42e868ca0.gif";